      var swiper = new Swiper('.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 40,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          scrollbar: {
              el: '.swiper-scrollbar',
              hide: false,
              dragSize:125,
          },
          breakpoints: {
              600: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:125,
                      },
              },
              640: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:125,
                      },
              },
              980: {
                  slidesPerView: 2,
                  spaceBetween: 80,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:125,
                      },
              },           
              1024: {
                  slidesPerView: 2,
                  spaceBetween: 97,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:240,
                      },
              },
              1280: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:360,
                      },
              },
              1025: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:302,
                      },
              },
              1441: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:320,
                      },
              },
              1700: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:360,
                      },
              },
              1800: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:390,
                      },
              },
              1910: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                  autoHeight: false,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:395,
                     
                      },

              },
              1920: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1930: {
                  slidesPerView: 4,
                  spaceBetween: 42,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1940: {
                  slidesPerView: 4,
                  spaceBetween: 43,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1950: {
                  slidesPerView: 4,
                  spaceBetween: 43,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
               1960: {
                  slidesPerView: 4,
                  spaceBetween: 43,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1970: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1980: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              1990: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2000: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
               2010: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2020: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              }, 
              2030: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
               2040: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2050: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              }, 
              2060: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
               2070: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2080: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              }, 
              2200: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2300: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2400: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
              2500: {
                  slidesPerView: 4,
                  spaceBetween: 44,
                  scrollbar: {
                      el: '.swiper-scrollbar',
                      hide: false,
                      dragSize:397,
                     
                      },
              },
          }
      });